import { Link } from 'react-router-dom';
import { ASSETS, EXTERNAL_LINKS, PRIMARY_NAV, RESOURCE_NAV } from '../../config/site';
import { useLocale } from '../../context/LocaleContext';

const socials = [
  ['Instagram', EXTERNAL_LINKS.instagram],
  ['TikTok', EXTERNAL_LINKS.tiktok],
  ['Facebook', EXTERNAL_LINKS.facebook],
  ['YouTube', EXTERNAL_LINKS.youtube],
  ['LinkedIn', EXTERNAL_LINKS.linkedin],
];

function SocialIcon({ name }) {
  if (name === 'Instagram') {
    return <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4.2" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" /></svg>;
  }
  if (name === 'TikTok') {
    return <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M14.3 3h3.1c.3 1.9 1.4 3.2 3.1 3.8v3.1a8.1 8.1 0 0 1-3.1-1v6.2a6 6 0 1 1-5.2-6V12a2.8 2.8 0 1 0 2.1 2.7V3Z" /></svg>;
  }
  if (name === 'Facebook') {
    return <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M14.2 21v-8h2.7l.4-3.1h-3.1v-2c0-.9.3-1.5 1.6-1.5h1.7V3.6c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.1H8V13h2.8v8h3.4Z" /></svg>;
  }
  if (name === 'YouTube') {
    return <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M21.6 7.2a3 3 0 0 0-2.1-2.1C17.6 4.6 12 4.6 12 4.6s-5.6 0-7.5.5a3 3 0 0 0-2.1 2.1A31 31 0 0 0 2 12a31 31 0 0 0 .4 4.8 3 3 0 0 0 2.1 2.1c1.9.5 7.5.5 7.5.5s5.6 0 7.5-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 22 12a31 31 0 0 0-.4-4.8ZM10 15.2V8.8l5.5 3.2-5.5 3.2Z" /></svg>;
  }
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.5 8.1H3.3V21h3.2V8.1ZM4.9 3A1.9 1.9 0 1 0 5 6.8 1.9 1.9 0 0 0 4.9 3ZM21 13.6c0-3.9-2.1-5.8-4.9-5.8-2.2 0-3.2 1.2-3.8 2.1V8.1H9.1V21h3.2v-6.4c0-1.7.3-3.4 2.5-3.4 2.2 0 2.2 2 2.2 3.5V21h3.2l.8-7.4Z" /></svg>;
}

export default function SiteFooter() {
  const { t } = useLocale();
  const footer = t.common.footer;

  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <div className="site-footer__brand">
          <Link to="/" aria-label={t.common.aria.home}><img src={ASSETS.logo} alt="YourApplicant" /></Link>
          <p>{footer.description}</p>
          <div className="site-footer__socials">
            {socials.map(([label, href]) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}><SocialIcon name={label} /></a>
            ))}
          </div>
        </div>

        <nav aria-label={footer.pagesTitle}>
          <strong>{footer.pagesTitle}</strong>
          {PRIMARY_NAV.map(([key, to]) => <Link key={key} to={to}>{footer.pages[key]}</Link>)}
        </nav>

        <nav aria-label={footer.informationTitle}>
          <strong>{footer.informationTitle}</strong>
          {RESOURCE_NAV.map(([key, to]) => <Link key={key} to={to}>{footer.resources[key === 'resume' ? 'cv' : key]}</Link>)}
        </nav>

        <div className="site-footer__contact">
          <strong>{footer.contactTitle}</strong>
          <a href="mailto:info@yourapplicant.ch">info@yourapplicant.ch</a>
          <a href="tel:+41441234567">+41 44 123 45 67</a>
          <a href={EXTERNAL_LINKS.map} target="_blank" rel="noopener noreferrer">{footer.address}</a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>{footer.copyright}</span>
        <span>{footer.createdBy} <a href="https://aleksanderdimitrov.dev" target="_blank" rel="noopener noreferrer">aleksanderdimitrov</a></span>
      </div>
    </footer>
  );
}
